import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

import axiosinstances from '../../../Helper/useAxios';
import { isSuperAdmin, isUserAdmin } from '../../../utils/comman/Common';
import '../product.css'
import CreateNewProduct from './CreateNewProduct';
import ProductList from './ProductList';

export default function CreateproductGroup() {
	const [axiosInstance] = axiosinstances();
	const [table, setTable] = useState([]) 
	const [entityType, setEntityType] = useState('')
	const [adddedProduct, setAddedProduct] = useState([])

  const token = JSON.parse(sessionStorage.getItem("token"));
	const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
	const fetchproductList = async () => {
		const response = await axiosInstance
		  .get(`/api/v1/pricing/product`, {
			headers: {
			  Authorization: `Bearer ${token}`,
			  "client-id": id,
			  role: "ROLE_RETAILER_FINXPAY",
			},
		  })
		  .then((res) => {
			if(res.status === 200){
			  setTable(res?.data?.all)
			}
		  })
		  .catch((err) => {
			//console.log(err);
		   
		  });
		if (response) {
		  const result = response.data.orders;
		  if (result) {
		  }
	
		  return response.data;
		}
		return false;
	  };
	  useEffect(() => {
		if (id !== undefined) {
		  fetchproductList()
		}
	  }, [id]);
	//console.log('table', table)
	//console.log('entityType', entityType)
	//console.log('adddedProduct',adddedProduct)
    // const getfilterData = () =>{
	// 	const ftrEntity = table.filter(data=>data.entityType === entityType)
	// 	return ftrEntity
	// }
	const getfilterData = () => {
		if (entityType !== "") {
		  const ftrEntity = table.filter((data) => data.entityType === entityType);
		  return ftrEntity;
		} else {
		  return table;
		}
	  };
	const entitleFilterData = React.useMemo(() => getfilterData(), [entityType, table]) 
	//console.log('entitleFilterData', entitleFilterData)
	const addedNewProduct = (product) =>{
		if(Array.isArray(adddedProduct) && !adddedProduct.includes(id)){
			setAddedProduct([...adddedProduct,product?.id])
			setEntityType(product?.entityType)
			
		}	
	}
const removeProduct = (id) =>{
	let temp = [...adddedProduct]
const index = temp.indexOf(id);
if (index > -1) {  
 temp.splice(index, 1); 
 //console.log('temp', temp)
 setAddedProduct([...temp])
}
}
  return (
	isSuperAdmin(id) && isUserAdmin(id) &&
    <div class="midcontant">
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-md-6 col-lg-5 col-xl-5">
				<div class="head">
					<div class="row">
						<div class="col-12 col-md-4 col-lg-5 col-xl-6"><h3>Product Listing</h3></div>
						{/* <div class="col-12 col-md-8 col-lg-7 col-xl-6">
						<div class="form-floating">
                        <select
                        class="form-select"
                        id="entityType"
                        onChange={(e)=>setEntityType(e.target.value)}
                        name="entityType"
                        value={entityType}
                        >
                        <option value="">Select</option>
                        <option value="CUSTOMER">CUSTOMER</option>
                        <option value="SUPPLIER">SUPPLIER</option>
                        <option value="RETAILER">RETAILER</option>

                        <option value="DISTRIBUTOR">DISTRIBUTOR</option>
                        <option value="PARTNER">PARTNER</option>
                        <option value="CORPORATE">CORPORATE</option>

                        <option value="WHITELABEL">WHITELABEL</option>
                        <option value="HO">HO</option>
                      </select>
                      <label for="entityType">Entity Type</label>
                    </div>
						</div> */}
					</div>					
				</div>
								
				<ProductList entitleFilterData={entitleFilterData} addedNewProduct={addedNewProduct} adddedProduct={adddedProduct} removeProduct={removeProduct}/>			
			</div>
			
			<CreateNewProduct adddedProduct={adddedProduct} removeProduct={removeProduct} entityType={entityType} setEntityType={setEntityType} />
		</div>
	</div>	
</div>
  )
}
